exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".trialStatusDisplay .trialBox{position:relative;border:1px solid #ddd;border-radius:5px;padding:12px 5px;padding-left:0;font-size:.8em;margin-top:15px}.trialStatusDisplay .trialBox:first-child{margin-top:0}.trialStatusDisplay .trialBox p{margin-bottom:0}.trialStatusDisplay .trialBox>div{position:relative;display:inline-block;vertical-align:middle}.trialStatusDisplay .imageBox{width:7%;text-align:center;margin-left:4%}.trialStatusDisplay .imageBox img{width:23px;height:auto;text-align:center}.trialStatusDisplay .statusBox{width:31%}.trialStatusDisplay .consultationBox{width:43%}.trialStatusDisplay .divider{margin-left:6%;margin-right:6%;width:1px;height:35px;background-color:#ddd}.trialStatusDisplay .expandLinkLine{text-align:right;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/upgrade/trial_status_display.scss
// module id = 1454
// module chunks = 0